import convert from "color-convert";
import { isEmpty, isNull, isString } from "lodash";

const DEFAULT_PRIMARY_LOTTIECOLOR = "0.369,0.643,0.247";
const DEFAULT_SECONDARY_LOTTIECOLOR = "0.173,0.267,0.31";

export interface IconColorPalette {
    primary: string;
    secondary?: string;
}

export const getJsonWithNewColors = (
    srcJson: object,
    color: IconColorPalette | null = null
) => {
    if (isNull(color) || isEmpty(color)) {
        // no color-change
        return srcJson;
    }

    const hasSecondaryColor =
        color.secondary &&
        isString(color.secondary) &&
        color.secondary.length > 0;

    const primaryColorToRgb = convert.hex.rgb(color.primary);

    const rgbToLottieColorPrimary = primaryColorToRgb
        .map((c) => (Number(c) / 256).toString().substring(0, 5))
        .join(",");

    if (!hasSecondaryColor) {
        // only primary color-change
        const jsonWithNewColor = JSON.parse(
            JSON.stringify(srcJson).replaceAll(
                DEFAULT_PRIMARY_LOTTIECOLOR,
                rgbToLottieColorPrimary
            )
        );
        return jsonWithNewColor;
    }

    // primary and secondary color-change
    const secondaryColorToRgb = convert.hex.rgb(color.primary);

    const rgbToLottieColorSecondary = secondaryColorToRgb
        .map((c) => (Number(c) / 256).toString().substring(0, 5))
        .join(",");

    const jsonWithNewColors = JSON.parse(
        JSON.stringify(srcJson)
            .replaceAll(DEFAULT_PRIMARY_LOTTIECOLOR, rgbToLottieColorPrimary)
            .replaceAll(
                DEFAULT_SECONDARY_LOTTIECOLOR,
                rgbToLottieColorSecondary
            )
    );
    return jsonWithNewColors;
};
